import { ArrowRight } from 'lucide-react';

import Avatar from './Avatar';

import { HELP_ASSISTANT_SUGGESTED_QUESTIONS } from '@/app/helpArticle/_enums';

import { Button } from '@/app/ui/button';

/** What the panel shows before the first question, with a few to start from. */
const Welcome = ({ onAsk }) => {
  return (
    <div className="flex min-h-full flex-col justify-center gap-6 py-6" data-testid="help-assistant-welcome">
      <div className="flex flex-col items-center gap-3 text-center">
        <Avatar size="lg" />
        <div>
          <h3 className="text-base font-semibold">How Can I Help?</h3>
          <p className="text-muted-foreground mx-auto mt-1 max-w-xs text-sm leading-6">
            Ask how to do something in Zebel. Answers come from the help articles, with links to the ones used.
          </p>
        </div>
      </div>
      <div className="space-y-2">
        <div className="text-muted-foreground text-xs font-medium">Try asking</div>
        {HELP_ASSISTANT_SUGGESTED_QUESTIONS.map((question) => (
          <SuggestedQuestion key={question} question={question} onAsk={onAsk} />
        ))}
      </div>
    </div>
  );
};

const SuggestedQuestion = ({ question, onAsk }) => {
  const handleClick = () => onAsk(question);

  return (
    <Button variant="outline" className="group h-auto w-full justify-between gap-3 px-3 py-2.5 text-left font-normal whitespace-normal" onClick={handleClick}>
      {question}
      <ArrowRight className="text-muted-foreground transition-transform group-hover:translate-x-0.5" />
    </Button>
  );
};

export default Welcome;
